export default __webpack_public_path__ + "static/media/among-us.bd049576.webp";